/**
 * @file ColorDotRow.tsx
 * @description Ряд кружков-цветов окна «Свой цвет» (phase19.16, партия SB120;
 * uiux-sb120-fields §3): «Цвета вашего сайта» и «Последние». Касание — 48 px
 * на телефоне и планшете, 36 px с мышью на ПК; цвет — кружок 32 px.
 */

export interface ColorDot {
  hex: string;
  /** Для подсказки и чтеца экрана: «Взять цвет «Акцент» #2f54eb». */
  label: string;
}

interface Props {
  title: string;
  dots: readonly ColorDot[];
  onPick: (hex: string) => void;
}

export function ColorDotRow({ title, dots, onPick }: Props) {
  return (
    <div role="group" aria-label={title} className="flex flex-col gap-1">
      <span className="type-caption text-on-surface-variant">{title}</span>
      <div className="flex flex-wrap gap-1">
        {dots.map((dot) => (
          <button
            key={`${dot.hex}-${dot.label}`}
            type="button"
            title={dot.label}
            aria-label={dot.label}
            onClick={() => onPick(dot.hex.slice(0, 7).toLowerCase())}
            className="inline-flex size-12 items-center justify-center rounded-full outline-none focus-visible:ring-2 focus-visible:ring-ring lg:size-9"
          >
            <span className="block size-8 rounded-full [box-shadow:inset_0_0_0_1px_var(--border)]" style={{ background: dot.hex }} />
          </button>
        ))}
      </div>
    </div>
  );
}
